import { ReportOriginType } from 'proto/generated/tintin_content_policy';

export const ROUTES = {
  POLICY: '/content-policy-reporting',
  LEGAL_REPORT_CONTENT: '/report-content',
  LEGAL_REPORTS: '/reports/legal',
  MAINTENANCE: '/maintenance',
  THANK_YOU: '*/thank-you',
} as const;

export const POLICY_ROUTES = [ROUTES.POLICY] as const;
export const LEGAL_ROUTES = [ROUTES.LEGAL_REPORT_CONTENT, ROUTES.LEGAL_REPORTS] as const;

export const getReportOriginTypeFromPath = (pathname: string): ReportOriginType => {
  const matchesAny = (routes: readonly string[]) => routes.some(route => pathname.startsWith(route));

  if (matchesAny(POLICY_ROUTES)) return ReportOriginType.REPORT_ORIGIN_POLICY;
  if (matchesAny(LEGAL_ROUTES)) return ReportOriginType.REPORT_ORIGIN_INFRINGEMENT;
  return ReportOriginType.REPORT_ORIGIN_INVALID;
};
